import reactKeyGenerator from '../helpers/reactKeyGenerator';

const fakePreviewEvents = [
  {
    state: 'It\'s On Its Way',
    timeStamp: '2019-10-23T06:11:00+00:00',
    renderKey: reactKeyGenerator.key(),
  },
  {
    state: 'Delivery Scheduled For Today',
    timeStamp: '2019-10-23T09:46:00+00:00',
    renderKey: reactKeyGenerator.key(),
  },
  {
    state: 'Out For Delivery',
    timeStamp: '2019-10-23T10:10:00+00:00',
    renderKey: reactKeyGenerator.key(),
  },
  {
    state: 'Delivered To Safe Location',
    timeStamp: '2019-10-23T14:18:00+00:00',
    renderKey: reactKeyGenerator.key(),
  },
];

const fakePreviewShipment = {
  carrier: 'Carrier',
  carrierTrackingPage: 'https://new.myhermes.co.uk/track.html#/parcel/7425881657409125/details',
  expectedDeliveryDate: '2019-10-23T14:30:00+00:00',
  id: 'sp_111111111111111111',
  shipmentState: {
    state: 'delivered_to_safe_location',
    stateLabel: 'Delivered To Safe Location',
  },
  trackingReference: 'C0001GB1234567891011',
  events: fakePreviewEvents,
};

const fakePreviewShipments = [
  fakePreviewShipment,
];

export default fakePreviewShipments;
